<template>
    <div>
        <div>
            <b-form-group>
                <b-form-checkbox-group
                    id="checkbox-group-1"
                    v-model="selected"
                    :options="options"
                    name="flavour-1"
                ></b-form-checkbox-group>
            </b-form-group>
        </div>
    </div>
</template>

<script>
export default {
    name: 'targetGroup',
    created: function(){
        this.$emit('sendSendings', this.selected)
    },
    updated: function(){
        this.$emit('sendSendings', this.selected)
    },
    data: function(){
        return{
            selected: ['sms'],
            options: [
            { text: 'SMS', value: 'sms'},
            { text: 'E-MAIL', value: 'email'},
            ]
        }
    }
}
</script>